var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallHappinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40000923_34523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.8789C7.125 18.8789 4.5 17.3789 3.0625 14.8789C1.625 12.4102 1.625 9.37891 3.0625 6.87891C4.5 4.41016 7.125 2.87891 10 2.87891C12.8438 2.87891 15.4688 4.41016 16.9062 6.87891C18.3438 9.37891 18.3438 12.4102 16.9062 14.8789C15.4688 17.3789 12.8438 18.8789 10 18.8789ZM7.125 13.0664C6.9375 12.8477 6.625 12.8477 6.40625 13.0039C6.1875 13.1914 6.1875 13.5039 6.34375 13.7227C7.0625 14.5352 8.25 15.3789 10 15.3789C11.7188 15.3789 12.9062 14.5352 13.625 13.7227C13.7812 13.5039 13.7812 13.1914 13.5625 13.0039C13.3438 12.8477 13.0312 12.8477 12.8438 13.0664C12.3125 13.7227 11.3438 14.3789 10 14.3789C8.625 14.3789 7.6875 13.7227 7.125 13.0664ZM6.5 9.37891C6.5 9.94141 6.9375 10.3789 7.5 10.3789C8.0625 10.3789 8.5 9.94141 8.5 9.37891C8.5 8.84766 8.0625 8.37891 7.5 8.37891C6.9375 8.37891 6.5 8.84766 6.5 9.37891ZM11.375 10.1914C11.9375 9.47266 13.0312 9.47266 13.5938 10.1914C13.75 10.4102 14.0625 10.4727 14.2812 10.2852C14.5 10.1289 14.5625 9.81641 14.375 9.59766C13.4375 8.31641 11.5312 8.31641 10.5938 9.59766C10.4062 9.81641 10.4688 10.1289 10.6875 10.2852C10.9062 10.4727 11.2188 10.4102 11.375 10.1914Z",
    fill: "url(#paint0_linear_40000923_34523)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40000923_34523",
    x1: 10,
    y1: 0.878906,
    x2: 10,
    y2: 20.8789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4545"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40000923_34523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallHappinessIcon);
export default __webpack_public_path__ + "static/media/small-happiness-icon.6f11c0f11b4d5ba2a26ec4dfd2673402.svg";
export { ForwardRef as ReactComponent };